// i18n area 'backups' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.ro-RO.meta.json.
import type { enUS } from './backups'

export const roRO: typeof enUS = {
  ckpt: {
    contents: 'Acceptă',
    contentsHint:
      'Ce poate ateriza aici. „Checkpointuri” este configurația clusterului, „Copii de date” sunt cele ale mașinilor virtuale: cele două lecturi se compun, o destinație poate accepta ambele.',
    content: { checkpoints: 'Checkpointuri', backups: 'Copii de date' },
    destinationsTitle: 'Destinații de backup',
    checkpointsTitle: 'Checkpointuri',
    restoreTitle: 'Restaurare',
    addDestination: 'Adaugă destinație',
    addDestinationTitle: 'Adaugă destinație de backup',
    editDestinationTitle: 'Modifică destinația',
    storage: 'Storage',
    storageHint:
      'Un storage dir-like (dir/NFS/CIFS/CephFS) — artefactele sunt fișiere obișnuite sub namespace-ul platformei.',
    schedule: 'Planificare',
    scheduleNone: 'Doar manual',
    scheduleHourly: 'La fiecare oră',
    scheduleDaily: 'Zilnică',
    scheduleWeekly: 'Săptămânală',
    scheduleHour: 'Ora',
    scheduleWeekday: 'Ziua',
    scheduleHint:
      'Checkpointurile planificate nu au un operator care să tasteze masterpass-ul: secretele din keystore sunt împachetate ca placeholder-uri.',
    retention: 'Retention',
    retentionHint:
      'Câte checkpointuri planificate se păstrează — sweeperul le elimină pe cele mai vechi peste numărul stabilit. Checkpointurile manuale și cele pre-restaurare nu sunt eliminate niciodată.',
    paused: 'În pauză',
    pausedHint:
      'Blackout-ul operatorului: cât timp e în pauză, pe această destinație nu se planifică și nu se curăță nimic — policy de date și checkpointuri deopotrivă. Rulările în curs nu sunt atinse niciodată.',
    orphanRuns: '{n} rulări orfane',
    orphanRunsHint:
      'Rulări planificate ale unor policy-uri care nu mai există pe această destinație: nicio retenție nu le guvernează — niciodată numărate, niciodată curățate — și doar o mână le șterge. Lentila „backups” din tvirt diagnose numește policy-urile eliminate.',
    rescan: 'Readoptă artefactele',
    rescanTitle: 'Readopția artefactelor pentru {name}',
    rescanHint:
      'Reconstruiește catalogul copiilor de rezervă (VM/CT/App) din manifestele artefactelor prezente pe destinație. Rândurile existente nu sunt niciodată atinse; copiile politicilor necunoscute rămân orfane (nu sunt niciodată curățate automat). Gestul de după o restaurare bootstrap.',
    masterpassDrWarning:
      'Scenariu de dezastru: discurile LUKS revin DOAR dintr-un checkpoint CU masterpass. Checkpoint-urile programate împachetează substituenți — faceți periodic un checkpoint manual cu masterpass.',
    policy: {
      title: 'Policy de backup al datelor',
      hint: 'Policy cu nume: ce obiecte (kind, taguri, scope-uri), cât de des, când poate porni o rulare și câte copii se păstrează. Gestul înrolării rămâne la proprietarul obiectului: tagurile se atribuie pe propriul lui scope.',
      add: 'Adaugă policy',
      column: 'Policy de date',
      name: 'Nume',
      nameHint:
        'Eticheta policy-ului, unică în destinație. Rulările urmează id-ul stabil al policy-ului: redenumirea este gratuită; ștergerea îi lasă rulările orfane (nu mai sunt numărate, nici curățate).',
      kindLocked: 'Familia de obiecte a unui policy existent nu se schimbă: creează un policy nou.',
      kindLabel: 'Obiecte',
      kind: { vm: 'Mașini virtuale', ct: 'Containere', app: 'Aplicații' },
      tags: 'Selector de taguri',
      tagsHint:
        'Perechi tag=valoare, separate prin virgulă, în AND. Tagurile și scope-urile goale nu selectează nimic — niciodată „totul”.',
      scopes: 'Scope-uri',
      scopesHint: 'Căi de scope (subarbori), separate prin virgulă, în OR între ele.',
      windowStart: 'Fereastră de la',
      windowEnd: 'Fereastră până la',
      windowHint:
        'Fereastra de execuție (HH:MM, ora locală; un început dincolo de sfârșit sare peste miezul nopții). Guvernează doar PORNIREA: o rulare care o depășește nu este omorâtă niciodată.',
      mode: 'Mod',
      modeHint: 'Incrementalul călărește familia de serii; o serie ruptă degradează la full, spus în jurnal.',
      modeFull: 'Full',
      modeIncremental: 'Incremental',
      requireQuiesce: 'Cere quiesce (guest agent)',
      paused: 'Policy în pauză',
      retentionNone: 'Păstrează tot',
      retentionCount: 'Număr',
      retentionGfs: 'Inele GFS',
      gfs: { keepLast: 'Ultimele', daily: 'Zilnice', weekly: 'Săptămânale', monthly: 'Lunare', yearly: 'Anuale' },
      gfsHint:
        'Pentru fiecare inel se păstrează backupul cel mai nou din fiecare dintre ultimele N perioade. Un backup păstrat își ține în viață întregul lanț — niciodată o bază cu orfani.',
      lastRun: 'Ultima rulare',
      neverRan: 'niciodată rulat'
    },
    lastCheckpoint: 'Ultimul checkpoint',
    neverRun: 'Nu a fost creat niciodată',
    createNow: 'Creează checkpoint',
    createNowTitle: 'Creează checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Protejează valorile secrete din keystore (argon2id → AES-256-GCM, per valoare). Nu este salvat niciodată: păstrează-l — fără el, o restaurare produce placeholder-uri în locul secretelor reale.',
    masterpassEmptyHint: 'Lasă gol pentru a împacheta placeholder-uri explicite în locul secretelor.',
    createStarted: 'Checkpoint în curs…',
    destinationInUseError: "'{name}' încă mai conține checkpointuri — șterge-le mai întâi.",
    origin: 'Origine',
    originManual: 'manuală',
    originSchedule: 'planificată',
    originPreRestore: 'pre-restaurare',
    originPreChange: 'pre-modificare',
    preChangeRetention: 'Checkpointuri pre-modificare',
    preChangeRetentionHint:
      'Gol = dezactivat. Prima scriere de configurație după o perioadă de liniște îngheață aici starea anterioară (origine pre-modificare); cele mai noi se păstrează până la numărul dat — retenție proprie, elagabilă.',
    diffTitle: 'Previzualizarea modificărilor',
    diffFailed: 'Previzualizarea a eșuat',
    diffRetry: 'Reîncearcă',
    diffCounts: '{changed} de modificat · {missing} de creat · {extra} în plus · {equal} identice',
    diffChanged: 'se modifică',
    diffMissing: 'ar fi creat',
    diffExtra: 'ar fi șters',
    diffJsonb: 'referințe jsonb neverificabile înainte de aplicare',
    diffSecret: 'câmpuri sigilate, necomparabile',
    diffMore: 'încă {n}…',
    diffNeeded: 'Pornirea se armează când previzualizarea reflectă selecția.',
    phase: 'Stare',
    phaseRunning: 'în curs',
    phaseComplete: 'completă',
    phaseError: 'eroare',
    secrets: 'Secrete',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholder-uri',
    size: 'Dimensiune',
    created: 'Creată',
    destination: 'Destinație',
    download: 'Descarcă .tvbk',
    deleteCheckpoint: 'Șterge checkpointul',
    noCheckpoints: 'Niciun checkpoint — creează unul dintr-o destinație.',
    families: 'Familii',
    generation: 'Generație',
    completedAt: 'Finalizată la',
    errorDetail: 'Detaliu eroare',
    manifest: 'Manifest',
    restoreHint: 'Încarcă un artefact .tvbk: exploratorul arată ce conține, apoi alegi ce restaurezi și cum.',
    uploadFile: 'Încarcă un fișier .tvbk',
    uploading: 'Încărcare…',
    uploadFailed: 'Artefactul nu a putut fi deschis',
    explorerTitle: 'Conținutul checkpointului',
    checkpointFrom: 'Checkpointul clusterului {cluster}, creat la {when} ({origin}, generația {generation})',
    otherCluster:
      'Acest checkpoint provine de pe un ALT cluster ({cluster}) — restaurarea cross-cluster sosește într-un round viitor.',
    encrypted: 'criptat',
    objectsCount: 'obiecte: {n}',
    mode: 'Mod',
    modeMerge: 'Merge — reconciliază: upsert pe cele selectate, nu șterge nimic',
    modeOverwrite:
      'Overwrite — câștigă checkpointul: o familie selectată integral este înlocuită în întregime (rândurile curente absente din checkpoint mor)',
    restoreMasterpassHint:
      'Masterpass-ul cu care a fost creat checkpointul. Fără el, secretele criptate sunt restaurate ca placeholder-uri explicite.',
    checkMasterpass: 'Verifică',
    masterpassOk: 'Masterpass corect',
    masterpassWrong: 'Masterpass greșit',
    parachuteDestination: 'Destinație parașută',
    parachuteHint: 'Înainte de a atinge orice rând, taskul creează aici un checkpoint automat pre-restaurare.',
    summaryTitle: 'Ce se va întâmpla',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'familia întreagă',
    summaryObjects: 'obiecte selectate: {n}',
    confirmHint:
      'Tastează numele clusterului ({name}) pentru a confirma — o restaurare rescrie configurația declarată.',
    confirmField: 'Numele clusterului',
    startRestore: 'Restaurează',
    restoreRunning: 'Restaurare în curs…',
    restoreDone: 'Restaurare completă — reconcilerii converg pe noua declarație.',
    restoreFailed: 'Restaurarea a eșuat',
    discard: 'Renunță',
    selectionEmpty: 'Selectează cel puțin o familie sau un obiect.'
  },

  backup: {
    intro: {
      title: 'Backupul datelor VM-urilor și containerelor',
      subtitle: 'Cărămizile pe care le folosește software-ul de backup extern',
      whatItIs:
        'TVirt expune patru primitive: snapshoturi quiesced, urmărirea modificărilor per disc, export NBD doar în citire și exportul configurației. Le pilotează Veeam, Bacula, Acronis și compania.',
      whatItIsNot:
        'TVirt nu este un produs de backup: nu planifică nimic, nu aplică retenție și nu păstrează nicio arhivă a datelor tale. Retenția, cataloagele și politicile de restaurare rămân la software-ul pe care îl folosești deja.'
    },
    cbt: {
      title: 'Urmărirea modificărilor',
      colVm: 'VM',
      colDisk: 'Disc',
      colState: 'Stare',
      colBitmaps: 'Bitmapuri',
      colObservedAt: 'Observat',
      colChangeId: 'Change ID',
      colMechanic: 'Mecanism',
      stateActive: 'Activ',
      stateInactive: 'Oprit',
      stateInconsistent: 'Inconsistent — următoarea copie trebuie să fie completă',
      stateBroken: 'Lanț întrerupt — dezactivați, apoi activați ca lanț nou',
      stateSnapshots: 'Mereu activ — delta între snapshoturi',
      stateUnavailable: 'Indisponibil pe acest disc',
      mechanic: {
        'qcow2-bitmap': 'Bitmap qcow2',
        'rbd-snapdiff': 'Diff de snapshoturi Ceph',
        'lvm-thin-delta': 'Delta thin pool',
        none: 'Niciunul'
      },
      empty:
        'Niciun disc de VM. Urmărirea se citește per disc: activați-o pe un disc qcow2 sau faceți snapshoturi pe rbd/SAN.',
      chainBroken: 'Lanț întrerupt',
      chainBrokenText:
        'Întrerupt de {reason}: {bitmaps}. Dezactivați bitmapul (lanțul este pierdut, următoarea copie este completă), apoi activați-l ca lanț nou.',
      lineages: 'Epoci',
      epochFrozen: 'înghețată în snapshotul {snapshot}',
      epochLost: 'pierdută ({cause})',
      epochRecording: 'înregistrează pe cap',
      milestones: 'Repere (snapshoturi)',
      enable: 'Activează urmărirea',
      disable: 'Dezactivează',
      reset: 'Resetează',
      changedAreas: 'Zone modificate',
      denied: 'Nu aveți permisiunea pe această VM',
      enableTitle: 'Activează urmărirea modificărilor',
      disableTitle: 'Dezactivează urmărirea modificărilor',
      resetTitle: 'Resetează bitmapul',
      areasTitle: 'Zone modificate',
      bitmapName: 'Numele bitmapului',
      bitmapNameHint: 'Un nume propriu: tvirt- și tvbk- aparțin platformei',
      granularity: 'Granularitate (octeți)',
      granularityHint: 'O putere a lui doi; implicit 65536',
      bitmap: 'Bitmap',
      disableHint: 'Elimină bitmapul și tot istoricul epocilor sale: următoarea copie trebuie să fie completă.',
      resetHint: 'Golește bitmapul — o bază nouă: un change ID anterior resetării nu mai poate fi compus.',
      areasFrom: 'De la snapshotul',
      areasTo: 'Până la snapshotul',
      areasRun: 'Calculează',
      areasResult: '{count} zone modificate, {bytes}',
      areasEmpty: 'Nicio zonă modificată între cele două snapshoturi',
      areasZero: 'zerouri',
      areasMore: 'afișate primele {shown} din {count}',
      submit: 'Confirmă',
      error: 'Acțiunea de urmărire a eșuat'
    },
    exports: {
      title: 'Exporturi NBD deschise',
      colVm: 'VM',
      colDisk: 'Disc',
      colSnapshot: 'Snapshot',
      colBitmap: 'Bitmap',
      colPhase: 'Fază',
      colNode: 'Nod',
      colEndpoint: 'Endpoint',
      colExpires: 'Expiră',
      colCreated: 'Deschis',
      colError: 'Eroare',
      phase: {
        preparing: 'În pregătire',
        ready: 'Gata',
        closed: 'Închis',
        error: 'Eșuat'
      },
      expiresIn: 'în {minutes} min',
      expired: 'expirat',
      empty: 'Niciun export. O sesiune de citire servește un disc la un snapshot unui client NBD; una de scriere umple un disc virgin al unei VM oprite. Ambele mor la expirare.',
      endpointHint: 'TLS cu CA clusterului; numele exportului este biletul — moare odată cu sesiunea',
      closeDenied: 'Nu aveți permisiunea de a închide exporturi pe această VM',
      open: 'Deschide export NBD',
      openTitle: 'Deschide un export NBD',
      openDisk: 'Disc',
      openBitmap: 'Bitmap (opțional)',
      openBitmapHint:
        'Publică epoca acelui bitmap înghețată în acest snapshot ca meta-context al extenturilor modificate (doar discuri qcow2)',
      openTtl: 'Durată (minute)',
      openSubmit: 'Deschide',
      openError: 'Exportul nu a putut fi deschis',
      colMode: 'Mod',
      mode: {
        read: 'Citire',
        write: 'Scriere'
      },
      caCertificate: 'CA clusterului',
      caCopy: 'Copiază PEM',
      caDownload: 'Descarcă ca-cert.pem',
      caHint: 'Scrie PEM-ul în ca-cert.pem într-un director privat și conectează-te cu nbds://…?tls-certificates=<director> (nbdcopy, nbdinfo) sau --object tls-creds-x509,dir=<director>,endpoint=client (qemu-img)',
      caAbsent: 'Sesiunea nu poartă CA (fără PKI)',
      openWrite: 'Deschide export de scriere',
      openWriteTitle: 'Deschide un export de scriere',
      openWriteIntro: 'Discul trebuie să fie virgin: născut gol, niciodată scris, fără snapshot; VM oprită. Restaurarea UMPLE discul, nu îl repară. Cât timp sesiunea este deschisă, VM nu pornește, nu face snapshot, nu se clonează, iar discul nu se mută.',
      openWriteSubmit: 'Deschide',
      openWriteError: 'Exportul de scriere nu a putut fi deschis',
      openWriteDenied: 'Nu ai permisiunea vm.restore.data pe această VM',
      openWriteStopped: 'Oprește VM pentru a deschide un export de scriere',
      fromDescription: 'Creează VM din description',
      fromDescriptionTitle: 'Creează o VM dintr-o description',
      fromDescriptionIntro: 'Description-ul din export-vm-meta se întoarce ca VM oprită cu discuri goale ale geometriei descrise — gata pentru exporturile de scriere, disc cu disc. Octeții nu trec pe aici: îi poartă restore-disk (CLI) sau clientul NBD al produsului de backup.',
      fromDescriptionDoc: 'Description (JSON)',
      fromDescriptionDocHint: 'Lipește documentul din export-vm-meta sau alege fișierul',
      fromDescriptionFile: 'Alege fișier…',
      fromDescriptionInvalid: 'Textul nu este un document JSON',
      fromDescriptionName: 'Numele VM-ului nou',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Scope-ul tău de pornire',
      fromDescriptionStorage: 'Storage-ul discurilor',
      fromDescriptionStorageHint: 'Fiecare disc se naște aici, în formatul implicit al storage-ului',
      fromDescriptionMetadataStorage: 'Storage-ul metadatelor',
      fromDescriptionSameAsStorage: 'Același ca al discurilor',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Fără bridge și fără rețea VM se naște fără plăci',
      fromDescriptionNetwork: 'Rețea logică (fabric/rețea)',
      fromDescriptionSubmit: 'Creează',
      fromDescriptionError: 'VM-ul nu a putut fi creat',
      fromDescriptionDone: 'VM creată: {name}',
      fromDescriptionOpen: 'Deschide VM',
      fromDescriptionDenied: 'Nu ai permisiunea vm.create',
      fromDescriptionStillRunning: 'Crearea este încă în curs: se continuă așteptarea'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Copii de date ale mașinilor virtuale',
      titleOnVm: 'Copii de date',
      empty:
        'Nicio copie. O copie duce discurile, varstore-ul UEFI și starea vTPM către o destinație și supraviețuiește mașinii virtuale.',
      colVm: 'VM',
      colCreated: 'Realizată la',
      colPhase: 'Rezultat',
      colDestination: 'Destinație',
      colContains: 'Conținut',
      colSize: 'Dimensiune',
      colOrigin: 'Origine',
      colMode: 'Tip',
      retentionChip: 'Retenție',
      retentionHint:
        'Retenția destinației poate șterge această copie fără să întrebe: s-a născut dintr-o planificare. Copiile manuale nu sunt măturate niciodată.',
      policyRemoved: 'Policy eliminat: {name}',
      policyRemovedHint:
        'Policy-ul care a planificat acest backup nu mai există: nicio retenție nu îl guvernează (niciodată curățat automat) — șterge-l manual când nu mai este necesar.',
      phase: {
        running: 'În curs',
        complete: 'Finalizată',
        error: 'Eșuată'
      },
      origin: {
        manual: 'Manuală',
        schedule: 'Planificată'
      },
      mode: {
        full: 'Completă',
        incremental: 'Incrementală'
      },
      contains: {
        disks: 'Discuri',
        varstore: 'Varstore UEFI',
        vtpm: 'Stare vTPM',
        snapshots: 'Instantanee'
      },
      vmState: {
        stopped: 'VM oprită',
        running: 'VM pornită (la cald)'
      },
      artifactClass: { metadata: 'Metadate', data: 'Date', secret: 'Secret' },
      detail: {
        tabOverview: 'Rezumat',
        tabArtefact: 'Artefact',
        id: 'Identificator',
        scope: 'Domeniu',
        vmState: 'Starea VM la copiere',
        pointInTime: 'Momentul datelor',
        completedAt: 'Încheiată la',
        node: 'Nodul care a copiat',
        error: 'Eroare',
        path: 'Director pe stocare',
        checksum: 'sha256 al manifestului',
        secretsExposed: 'Material sensibil în clar',
        secretsExposedYes: 'Da — destinația nu criptează',
        secretsExposedNo: 'Nu',
        baseBackup: 'Copie de bază',
        tabManifest: 'Manifest',
        manifestHint:
          'Indexul în clar al artefactului: un fișier pe rând cu sha256-ul său. Directorul se verifică și fără TVirt — ajung qemu-img, tar și jq.',
        manifestEmpty: 'Manifestul nu enumeră fișiere.',
        manifestError: 'Manifestul nu poate fi citit',
        colEntry: 'Fișier',
        colClass: 'Clasă',
        colSha: 'sha256'
      },
      create: {
        action: 'Copiază acum',
        title: 'Copiază acum',
        submit: 'Pornește copia',
        destination: 'Destinație',
        destinationHint: 'Doar destinațiile care acceptă copii.',
        noDestinations: 'Nicio destinație nu acceptă copii: creează una în Sistem → Checkpointuri.',
        contentsHint:
          'Călătoresc toate discurile, varstore-ul UEFI și starea vTPM. Ultimele două sunt esența: un guest sigilat trebuie să pornească din nou.',
        error: 'Copia nu a pornit',
        stillRunning: 'Copia este încă în curs — copierea continuă chiar dacă închizi.',
        vmRunning:
          'Mașina este {phase}: copia cere o VM stabilă — oprită pentru copia la rece, pornită pentru cea la cald.'
      },
      restore: {
        action: 'Restaurează',
        title: 'Restaurează',
        intro:
          'Restaurarea este ireversibilă. Alege unde se întorc datele: într-o mașină nouă sau peste cea de origine.',
        modeNewVm: 'Restaurează într-o VM NOUĂ',
        modeNewVmHint:
          'Nu atinge nimic din ce există — este opțiunea cu care se verifică o copie. Identificator nou și adrese MAC proaspăt bătute.',
        modeOver: 'Suprascrie VM de origine',
        modeOverHint: 'Distruge datele actuale ale VM țintă, fără cale de întoarcere. Mașina trebuie să fie oprită.',
        newName: 'Numele noii VM',
        newNameHint: 'Trebuie să fie liber în domeniul de destinație.',
        storage: 'Stocarea discurilor',
        storageHint:
          'Obligatoriu: manifestul înregistrează dimensiunea și formatul unui disc, niciodată stocarea pe care se afla.',
        metadataStorage: 'Stocarea pentru varstore și vTPM',
        metadataStorageHint: 'Unde aterizează identitatea UEFI și starea vTPM.',
        sameAsStorage: 'Aceeași cu a discurilor',
        bridge: 'Bridge-ul gazdei',
        bridgeHint:
          'Fiecare placă înregistrată revine pe acest bridge cu un MAC nou. Lăsat gol, mașina se naște fără plăci — valoarea implicită mai sigură.',
        overwriteTitle: 'Ești pe cale să suprascrii această mașină',
        overwriteName: 'Nume',
        overwriteId: 'Identificator',
        overwriteDisks: 'Discuri care vor fi rescrise',
        overwriteNoDisks: 'Niciun disc.',
        overwriteKeeps:
          'Rămân intacte identificatorul, numele, domeniul, plăcile de rețea și adresele MAC: o copie sunt DATELE, configurația este checkpointul.',
        confirmField: 'Numele mașinii',
        confirmHint: 'Scrie {name} pentru a confirma.',
        targetLoading: 'Se citește mașina țintă…',
        targetRunning: 'Mașina țintă este {phase}: restaurarea rescrie octeții de sub guest, deci o cere oprită.',
        targetGone: 'Mașina de origine nu mai poate fi citită: rămâne restaurarea într-o mașină nouă.',
        onlyComplete: 'Copia este {phase}: doar o copie finalizată poate restaura.',
        submitNewVm: 'Restaurează în noua mașină',
        submitOver: 'Suprascrie',
        error: 'Restaurarea nu a pornit',
        stillRunning: 'Restaurarea este încă în curs — copierea discurilor întregi cere timp.'
      }
    },
    guest: {
      title: {
        ct: 'Copiile de rezervă ale datelor containerelor',
        app: 'Copiile de rezervă ale datelor App-urilor'
      },
      tabTitle: 'Copii de rezervă',
      empty: 'Nicio copie. O copie duce datele persistente către o destinație și supraviețuiește obiectului său.',
      colSubject: {
        ct: 'Container',
        app: 'App'
      },
      colCreated: 'Realizată',
      colPhase: 'Rezultat',
      colDestination: 'Destinație',
      colContains: 'Conținut',
      colSize: 'Dimensiune',
      colOrigin: 'Origine',
      policyRemoved: 'Policy eliminat: {name}',
      policyRemovedHint:
        'Policy-ul care a planificat acest backup nu mai există: nicio retenție nu îl guvernează (niciodată curățat automat) — șterge-l manual când nu mai este necesar.',
      phase: {
        running: 'În curs',
        complete: 'Finalizată',
        error: 'Eșuată'
      },
      origin: {
        manual: 'Manuală',
        schedule: 'Programată'
      },
      state: {
        stopped: 'Obiect oprit',
        running: 'Obiect pornit (înghețat)'
      },
      contains: {
        rootfs: 'Arborele rootfs',
        config: 'Configurație',
        volumes: 'Volume persistente',
        root: 'Root persistent'
      },
      artifactClass: {
        metadata: 'Metadate',
        data: 'Date',
        secret: 'Secret'
      },
      create: {
        action: 'Fă copia acum',
        title: 'Copie de rezervă nouă',
        submit: 'Pornește copia',
        error: 'Copia nu a pornit',
        destination: 'Destinație',
        destinationHint: 'Doar destinațiile care acceptă copii de date.',
        noDestinations: 'Nicio destinație nu acceptă copii de date: adăugați „Copii de date” unei destinații.',
        hint: {
          ct: 'Călătorește întregul arbore rootfs, fidel (proprietari numerici, xattr, ACL), plus configurația declarată în manifest. Un container pornit este ÎNGHEȚAT pe toată durata împachetării: copie crash-consistent, declarată.',
          app: 'Călătoresc DOAR volumele persistente (și root-ul persistent), plus configurația în manifest. Efemerul este exclus prin ratificare și manifestul îl numește; valorile env declarate secrete nu călătoresc.'
        },
        stillRunning: 'Copia încă în curs — împachetarea arborilor întregi ia timp.'
      },
      detail: {
        tabOverview: 'Prezentare',
        tabManifest: 'Manifest',
        id: 'Identificator',
        scope: 'Domeniu',
        state: 'Starea la copiere',
        pointInTime: 'Datele la momentul',
        completedAt: 'Încheiată',
        node: 'Nodul care a copiat',
        error: 'Eroare',
        path: 'Directorul pe stocare',
        checksum: 'sha256 al manifestului',
        manifestHint:
          'Indexul artefactului: o intrare pe fișier cu sha256-ul său — fără hash-uri, „copia există” e un act de credință.',
        manifestError: 'Manifestul nu poate fi citit',
        manifestEmpty: 'Niciun artefact în manifest.',
        colEntry: 'Fișier',
        colClass: 'Clasă',
        colSha: 'sha256',
        excluded: 'Exclus prin ratificare (nu călătorește)',
        secretKeys: 'Chei env secrete omise (#307) — reintroduceți-le după o restaurare'
      },
      restore: {
        action: 'Restaurează',
        title: 'Restaurare',
        submit: 'Restaurează',
        error: 'Restaurarea nu a pornit',
        stillRunning: 'Restaurarea încă în curs — extragerea arborilor întregi ia timp.',
        onlyComplete: 'Copia este {phase}: doar o copie finalizată poate restaura.',
        asNew: {
          ct: 'Într-un container NOU — nu distruge nimic: gestul cu care se verifică o copie',
          app: 'Într-o App NOUĂ — nu distruge nimic: gestul cu care se verifică o copie'
        },
        over: {
          ct: 'PESTE containerul sursă — întregul arbore rootfs este înlocuit',
          app: 'PESTE App-ul sursă — conținutul fiecărui volum persistent este înlocuit'
        },
        name: 'Numele noului obiect',
        storage: 'Stocare',
        storageHint: 'Unde aterizează datele restaurate — manifestul nu înregistrează niciodată pool-ul pierdut.',
        storageDeclared: 'Stocările declarate în manifest',
        bridge: 'Bridge-ul gazdei',
        bridgeHint:
          'Fiecare placă înregistrată revine pe acest bridge cu un MAC proaspăt. Gol = se naște neconectat, implicit cel mai sigur.',
        node: 'Nod',
        nodeHint: 'Membrul pe care App-ul renaște: nodul este identitate de cluster și nu vine niciodată din manifest.',
        secretKeysWarning:
          'Valorile env declarate secrete nu călătoresc în copie: copia renăscută le vrea reintroduse (jurnalul task-ului numește cheile).',
        overInventory: 'Sunteți pe cale să suprascrieți acest obiect',
        confirmType: 'Tastați {name} pentru a confirma',
        targetGone: 'Obiectul sursă nu mai poate fi citit: rămâne restaurarea ca nou.',
        targetLoading: 'Se citește obiectul țintă…',
        targetRunning: 'Obiectul țintă rulează: restaurarea înlocuiește octeții de sub guest și îl vrea oprit.'
      }
    }
  }
}
